import { useCallback } from 'react'

import { Status, useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'
import { SuperEvent } from 'super-events/types'

const useGetSuperEvents = (): [() => Promise<SuperEvent[]>, Status<SuperEvent[]>] => {
  const organization = useCurrentOrg()
  const [request, status] = useFetchRefactored<SuperEvent[]>()

  const getSuperEvents = useCallback(() => {
    return request({
      method: 'get',
      url: `/organizations/${organization.id}/super_events`,
    })
  }, [organization.id, request])

  return [getSuperEvents, status]
}

export default useGetSuperEvents
